import $ from 'jquery'
import Modaal from 'modaal'

const initModaalPopIFrame = function() {
    $('.showpopiframe').modaal({
      type: 'iframe'
    })
}

$(document).ready(function(){
    initModaalPopIFrame()
})



// WEBPACK FOOTER //
// ./src/components/showpopiframe/index.js